module.exports = __webpack_public_path__ + "img/partner3.5369f3d4.jpg";